export {
  getTextModelRequired,
  getTextModel,
  languageByExt,
  subscribe,
  setMonacoModel,
} from "./monaco";
